import { createFileRoute } from "@tanstack/react-router";
import { TextCampaignDetailPage } from "@/components/text-banking/TextCampaignDetailPage";

export const Route = createFileRoute(
	"/_app/_/text-banking/$campaignId",
)({
	component: OutreachTextCampaignDetailPage,
});

function OutreachTextCampaignDetailPage() {
	const { campaignId } = Route.useParams();
	return <TextCampaignDetailPage textCampaignId={Number(campaignId)} backTo="/text-banking" />;
}
